Vue.component("MpOperatorChange", {

    props: {
        field: {
            type: String,
            required: true,
            default: ''
        },
        labels: {
            type: Object,
            required: true,
            default: {},
        },
        previous: {
            type: String,
            required: false,
            default: ''
        },
        current: {
            type: String,
            required: false,
            default: ''
        }
    },

    data: function() {
        return {};
    },

    computed: {},

    methods: {
        init: function() {},
    },

    mounted: function() {},

    template: '\
    <div class="operatorchange">\
        <div class="operatorchange__field">{{ labels[field] }}</div>\
        <div class="operatorchange__change">\
            <span class="operatorchange__change-previous">{{ previous }}</span>\
            <span class="operatorchange__change-current">{{ current }}</span>\
        </div>\
    </div>',
});

